import { useRouter } from "next/router";
import posthog from "posthog-js";
import { useEffect } from "react";

const AUTO_CAPTURE_ENABLED = true;
const isProd = process.env.NODE_ENV === "production";

export function usePageViewTracking() {
  const router = useRouter();

  useEffect(() => {
    if (!isProd || AUTO_CAPTURE_ENABLED) return;

    const handleRouteChange = (url: string) => {
      posthog.capture("$pageview", {
        page_path: url,
        referrer: document.referrer,
      });
    };

    handleRouteChange(window.location.pathname);
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => router.events.off("routeChangeComplete", handleRouteChange);
  }, [router]);
}
